import React from "react";
import ReactDOM from "react-dom/client";
import * as Sentry from "@sentry/react";
import "@/index.css";
import App from "@/App";
import { initSentry } from "@/lib/sentry";

// Initialize Sentry before React mounts so even render-time errors are captured.
initSentry();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary
      fallback={({ error, resetError }) => (
        <div
          style={{
            minHeight: "100vh",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            background: "#0B2240",
            color: "#F6F2EA",
            padding: "40px 20px",
            fontFamily: "system-ui, sans-serif",
            textAlign: "center",
          }}
        >
          <div style={{ maxWidth: 520 }}>
            <p
              style={{
                fontSize: 11,
                letterSpacing: "0.22em",
                textTransform: "uppercase",
                color: "#D4AF37",
                fontWeight: 600,
                marginBottom: 18,
              }}
            >
              Something Went Wrong
            </p>
            <h1 style={{ fontSize: 36, fontWeight: 700, marginBottom: 16, lineHeight: 1.15 }}>
              We hit an unexpected error.
            </h1>
            <p style={{ fontSize: 15, color: "rgba(246,242,234,0.7)", marginBottom: 28, lineHeight: 1.6 }}>
              Our team has been notified automatically. You can refresh the page, or call us directly at{" "}
              <a data-testid="index-a-2" href="tel:18445993355" style={{ color: "#D4AF37", textDecoration: "none", fontWeight: 600 }}>
                1-844-599-3355
              </a>
              .
            </p>
            <button data-testid="index-button-1"
              onClick={resetError}
              style={{
                background: "linear-gradient(180deg,#E8D89E 0%,#D4AF37 50%,#B99610 100%)",
                color: "#0B2240",
                fontWeight: 700,
                fontSize: 13,
                padding: "12px 28px",
                borderRadius: 12,
                border: "none",
                cursor: "pointer",
                marginRight: 12,
              }}
            >
              Try again
            </button>
            <a data-testid="index-a-1"
              href="/"
              style={{
                display: "inline-block",
                color: "rgba(246,242,234,0.85)",
                padding: "12px 24px",
                border: "1px solid rgba(255,255,255,0.15)",
                borderRadius: 12,
                textDecoration: "none",
                fontWeight: 600,
                fontSize: 13,
              }}
            >
              Return home
            </a>
            {error?.message && process.env.NODE_ENV !== "production" && (
              <pre
                style={{
                  marginTop: 32,
                  padding: 16,
                  background: "rgba(0,0,0,0.3)",
                  borderRadius: 8,
                  fontSize: 11,
                  color: "rgba(246,242,234,0.6)",
                  textAlign: "left",
                  overflowX: "auto",
                  maxWidth: "100%",
                }}
              >
                {String(error.message)}
              </pre>
            )}
          </div>
        </div>
      )}
    >
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
);
